module.exports = __webpack_public_path__ + "img/parallax1-1920p.f1b3e262.jpg";